"use strict";

(function ($) {
  $("document").ready(function () {

	  //change_user_role_form
	  $('#change_user_role_form').on('submit', function(e) {
		  e.preventDefault();
		  const change_user_role_form = $("#change_user_role_form");
		  const formData = new FormData(change_user_role_form[0]);
		  const rest_endpoint = change_user_role_form.attr('action');

		  const request = $.ajax({
			  url: rest_endpoint,
			  method: "POST",
			  data: formData,
			  async: false,
			  cache: false,
			  contentType: false,
			  processData: false,
			  beforeSend: function (xhr) {
				  xhr.setRequestHeader('X-WP-Nonce', change_user_role_form.find('input[name="rest_auth_nonce"]').val());
			  }
		  });

		  request.done(function (msg) {
			  //console.log(msg);
			  jQuery('#changeUserRoleModal').modal('toggle');
			  setTimeout(function(){
				  window.location.reload();
			  }, 1500);
		  });
		  request.fail(function (jqXHR, textStatus) {
			  //console.log(jqXHR,textStatus);
		  });
	  });
  });

})(jQuery);
